// Mock data for Nifty Travel Podcast Landing Page

export const mockData = {
  // Hero Section
  hero: {
    title: "Be a Guest on the Nifty Travel Podcast",
    subtitle: "Share your travel story, inspire thousands, and grow your visibility in the travel industry.",
    ctaText: "Apply to Be a Guest"
  },

  // Benefits Section
  benefits: [
    {
      icon: "eye",
      title: "Visibility",
      description: "Reach a growing global audience of travel lovers & professionals."
    },
    {
      icon: "award",
      title: "Authority",
      description: "Position yourself as a trusted voice in travel."
    },
    {
      icon: "book-open",
      title: "Storytelling",
      description: "Share the story behind your journey, brand, or expertise."
    },
    {
      icon: "users",
      title: "Networking",
      description: "Join a community of like-minded travel professionals."
    }
  ],

  // Podcast Info
  podcast: {
    description: "The Nifty Travel Podcast dives into journeys, challenges, and opportunities across the travel world — from consultants and entrepreneurs to destination specialists and adventurers.",
    stats: {
      episodes: "25+",
      downloads: "10K+",
      countries: "45+"
    }
  },

  // Host Info
  host: {
    name: "Alex Wingent",
    title: "Host & Travel Navigator",
    bio: "With 20+ years in travel, IT, and marketing, I blend storytelling with strategy to create conversations that are inspiring and practical. I'm passionate about showcasing the incredible people behind travel experiences and helping them share their expertise with the world.",
    experience: "20+ years in travel industry"
  },

  // Process Steps
  process: [
    {
      step: 1,
      title: "Friendly Prep Call",
      description: "We'll chat about your story and what you'd like to share (optional but recommended)."
    },
    {
      step: 2,
      title: "Easy Recording",
      description: "Around 60 minutes of conversation recorded online at your convenience."
    },
    {
      step: 3,
      title: "Professional Production",
      description: "Light editing and professional publishing across all podcast platforms."
    },
    {
      step: 4,
      title: "Promotion & Reach",
      description: "Social media promotion tagging you and your business for maximum exposure."
    }
  ],

  // Sample Testimonials (placeholders)
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      title: "Travel Consultant, Wanderlust Adventures",
      quote: "Being on the Nifty Travel Podcast was incredible! The conversation felt natural and I've received so many new clients since it aired.",
      rating: 5
    },
    {
      id: 2,
      name: "Mark Thompson",
      title: "Destination Specialist, European Escapes",
      quote: "The host made me feel so comfortable, and the reach has been amazing. I've connected with travel professionals from around the world.",
      rating: 5
    },
    {
      id: 3,
      name: "Lisa Chen",
      title: "Adventure Travel Expert",
      quote: "Professional, engaging, and impactful. This podcast really helped establish my authority in the adventure travel space.",
      rating: 5
    }
  ],

  // Featured Episodes (real episodes)
  featuredEpisodes: [
    {
      id: 1,
      title: "Building a Passion for Storytelling from Scratch",
      guest: "Oskar Halidar Skowronek",
      description: "How to turn a strong desire to tell stories into multiple directions.",
      duration: "45 min",
      youtubeUrl: "https://youtu.be/R78d49TCoPo"
    },
    {
      id: 2,
      title: "People lead more adventure-filled lives",
      guest: "Chris Whittaker",
      description: "Always hiring locally helps build long-term relationships with the people who are visited.",
      duration: "38 min",
      youtubeUrl: "https://youtu.be/ZOnj4l-GNls"
    },
    {
      id: 3,
      title: "Showing people animals in the wild and protecting the environment",
      guest: "Chris Manovah",
      description: "Leaving footprints and taking away memories are the first steps towards responsible and sustainable tourism.",
      duration: "42 min",
      youtubeUrl: "https://youtu.be/b74IBNTeQlA"
    },
    {
      id: 4,
      title: "Understanding communities through conversation",
      guest: "Angie Drake",
      description: "Why sustainable travel is more important than ever and what we can all do.",
      duration: "40 min",
      youtubeUrl: "https://youtu.be/vpo97RWvfpE"
    }
  ],

  // Contact Info
  contact: {
    email: "alex@niftytravelpodcast.com",
    linkedin: "www.linkedin.com/in/alex-wingent-7ft",
    youtube: "https://www.youtube.com/@niftytravelpodcast",
    bookingUrl: "https://calendar.app.google/Xgfboy7o2hyn9yww9",
    testimonialsUrl: "https://niftytravelpodcast.com/testimonials"
  }
};

// Form handling mock functions
export const submitGuestApplication = async (formData) => {
  // Mock API call
  console.log('Guest application submitted:', formData);
  
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Mock success response
  return {
    success: true,
    message: "Thank you for your application! We'll be in touch within 48 hours."
  };
};

export const subscribeNewsletter = async (email) => {
  // Mock newsletter subscription
  console.log('Newsletter subscription:', email);
  
  await new Promise(resolve => setTimeout(resolve, 500));
  
  return {
    success: true,
    message: "Successfully subscribed to our newsletter!"
  };
};